/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Precheck_TitleInputs */

const en_embed_captions_precheck_title = /** @type {(inputs: Embed_Captions_Precheck_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Pre-Checks`)
};

const fr_embed_captions_precheck_title = /** @type {(inputs: Embed_Captions_Precheck_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pre-verifications d'exportation`)
};

const de_embed_captions_precheck_title = /** @type {(inputs: Embed_Captions_Precheck_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export-Vorabprüfungen`)
};

const it_embed_captions_precheck_title = /** @type {(inputs: Embed_Captions_Precheck_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controlli preliminari all'esportazione`)
};

const ru_embed_captions_precheck_title = /** @type {(inputs: Embed_Captions_Precheck_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительные проверки при экспорте`)
};

const es_embed_captions_precheck_title = /** @type {(inputs: Embed_Captions_Precheck_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprobaciones previas a la exportación`)
};

const zh_cn2_embed_captions_precheck_title = /** @type {(inputs: Embed_Captions_Precheck_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出口预检查`)
};

const ja_embed_captions_precheck_title = /** @type {(inputs: Embed_Captions_Precheck_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポートの事前チェック`)
};

const hi_embed_captions_precheck_title = /** @type {(inputs: Embed_Captions_Precheck_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात पूर्व-जांच`)
};

const pt_pt2_embed_captions_precheck_title = /** @type {(inputs: Embed_Captions_Precheck_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificações prévias para exportação`)
};

/**
* | output |
* | --- |
* | "Export Pre-Checks" |
*
* @param {Embed_Captions_Precheck_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_precheck_title = /** @type {((inputs?: Embed_Captions_Precheck_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Precheck_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_precheck_title(inputs)
	if (locale === "de") return de_embed_captions_precheck_title(inputs)
	if (locale === "it") return it_embed_captions_precheck_title(inputs)
	if (locale === "ru") return ru_embed_captions_precheck_title(inputs)
	if (locale === "es") return es_embed_captions_precheck_title(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_precheck_title(inputs)
	if (locale === "ja") return ja_embed_captions_precheck_title(inputs)
	if (locale === "hi") return hi_embed_captions_precheck_title(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_precheck_title(inputs)
	return en_embed_captions_precheck_title(inputs)
});